import './StateLabel-aaa1d148.css';

var classes = {"StateLabel":"prc-StateLabel-StateLabel-ukDwa","Icon":"prc-StateLabel-Icon-NuDm4"};

export { classes as default };
